export default class PromotionDuplicate extends HTMLAnchorElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.watchers();
    }

    watchers() {
        this.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            var $this = $(this);

            swal({
                title: "Confirmation",
                text: "Etes vous sur de vouloir dupliquer le code promotionnel \""+ $this.attr("data-code")+"\" ?",
                allowOutsideClick: false,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ee0000',
                cancelButtonText: 'Non',
                confirmButtonText: 'Oui',
            }).then(function (result) {
                if (result.value
                ) {
                    $.ajax({
                        url: $this.attr('href'),
                        method: 'GET',
                        async: true,
                        cache: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            window.AppDatatable.table.ajax.reload();
                            toastr.success('Le code promotionel a été dupliqué');
                            swal.close();
                        },
                        error: function (data) {
                            swal.close();
                        }
                    });
                }
            });
        });
    }
}
